import React from 'react';
import { SparkDialog, SparkSwitcher } from 'sharedComponents/UI';
import { Box, Grid } from '@mui/material';
import PreviewContent, {
  VIEWS,
  ViewType,
} from '../SparkBuilderDrawers/RightDrawer/PreviewContent';
import { useSparkBuilderStore } from 'stores';
import { useFormByID } from 'hooks/Forms';
import { SparkSurveyForm } from 'external/SurveyJs';
import SparkOutputPreviewContainer from './SparkOutputPreviewContainer';
import PreviewMobileIcon from 'components/SVG/PreviewMobileIcon';
import PreviewDesktopIcon from 'components/SVG/PreviewDesktopIcon';

type SparkPreviewModalProps = {
  open: boolean;
  onClose: () => void;
};
function SparkPreviewModal({ open, onClose }: SparkPreviewModalProps) {
  const [currentView, setCurrentView] = React.useState<string>('Input');
  const [selectedView, setSelectedView] = React.useState<ViewType>(
    VIEWS.DESKTOP
  );
  const joinedSpark = useSparkBuilderStore((state) => state.joinedSpark);
  const { form } = useFormByID(joinedSpark?.attributes.inputFormID);

  const handleModalClose = () => {
    onClose();
  };

  return (
    <SparkDialog
      title=''
      hideTitle={true}
      open={open}
      onClose={handleModalClose}
      closeButtonStyles={{ top: 20, right: 20 }}
      dialogContentStyles={{ overflow: 'hidden' }}
    >
      <Grid container alignItems='center'>
        <Box
          display='flex'
          alignItems='center'
          justifySelf='flex-start'
          gap={2}
          padding={1}
          bgcolor={(theme) => theme.palette.primary.light}
          borderRadius='10px'
        >
          <span
            onClick={() => setSelectedView('desktop')}
            style={{ cursor: 'pointer' }}
          >
            <PreviewDesktopIcon
              color={selectedView === 'desktop' ? '#6267AC' : 'black'}
            />
          </span>
          <span
            onClick={() => setSelectedView('mobile')}
            style={{ cursor: 'pointer' }}
          >
            <PreviewMobileIcon
              color={selectedView === 'mobile' ? '#6267AC' : 'black'}
            />
          </span>
        </Box>
        <SparkSwitcher
          firstValue='Input'
          secondValue='Output'
          defaultValue='Input'
          onChange={(view) => setCurrentView(view)}
          containerStyles={{
            width: '30%',
            margin: 'auto',
            transform: 'translate(-10%,0)',
          }}
        />
      </Grid>
      <Grid item>
        <PreviewContent selectedView={selectedView}>
          {currentView === 'Input' ? (
            <SparkSurveyForm
              id={form?.id || ''}
              formConfigJSON={form?.attributes.config || ''}
              previewMode={true}
              showProgressBar='off'
              formContainerStyles={{
                paddingBottom: 3,
                '& .sd-root-modern': {
                  bgcolor: 'transparent !important',
                  paddingX: 2,
                },
                '& .sd-body.sd-body--static': {
                  marginX: 0,
                  paddingTop: '16px',
                  maxWidth: 'unset',
                },
                '& .sd-root-modern.sd-root-modern--full-container': {
                  scrollbarWidth: 'none',
                },

                '& .sd-body.sd-body--static .sd-body__timer, .sd-body.sd-body--static .sd-body__navigation, .sd-body.sd-body--static .sd-body__page':
                  {
                    paddingX: '1px',
                  },
                '& .sd-root-modern--mobile .sd-body.sd-body--responsive, .sd-root-modern--mobile .sd-body.sd-body--static':
                  {
                    paddingX: '1px',
                  },
              }}
            />
          ) : (
            <SparkOutputPreviewContainer />
          )}
        </PreviewContent>
      </Grid>
    </SparkDialog>
  );
}

export default SparkPreviewModal;
